import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from 'tss-react/mui';

import {Topbar} from './components';
import { Box } from '@mui/material';

const useStyles = makeStyles()(theme => ({

   content: {
      marginTop: '64px',
      flex:1,
      display: 'flex',
      flexDirection: 'column',
      paddingTop: theme.spacing(2)
   }
}));

const Minimal = props => {
   const {children} = props;
   const { classes } = useStyles();
   return (
      <Box display="flex" flexDirection="column" height="100vh">
         <Topbar/>
         <Box
            component="main"
            className={classes.content}
         >
            {children}
         </Box>
      </Box>
   );
};

Minimal.propTypes = {
   children: PropTypes.node,
   className: PropTypes.string
};

export default Minimal;
